import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import './registerServiceWorker'
import 'amfe-flexible'
import i18n from './i18n'
import routes from './routes'
import services from './services'
import fetch, { fetchNothing } from './utils/fetch'
import { LS_KEYS } from './constants'
import ls from './utils/local-storage'
import { Notify } from 'vant'

Vue.config.productionTip = false
Vue.use(Router)

const router = new Router({ routes })

const getLoginPageName = () => {
  return ls.get(LS_KEYS.ENCRYPTED_PWD) ? 'gesture-login' : 'login'
}
const isLoginPage = (route) => (route.name === 'login' || route.name === 'gesture-login')

let authInfo = null
const auth = (key) => {
  authInfo = authInfo || ls.get(LS_KEYS.AUTHORIZATION)
  console.log('zfauth', key)
  return !!authInfo[key]
}

router.beforeEach((to, from, next) => {
  // cancel fetches
  if (window.axiosSources) {
    Object.values(window.axiosSources).forEach(source => source.cancel())
  }
  // go 2 login page if not login
  if (!isLoginPage(to) && !ls.has(LS_KEYS.PGT)) {
    next({ name: getLoginPageName() })
  // go 2 change password if needed
  } else if (!isLoginPage(to) && to.name !== 'change-password' && ls.get(LS_KEYS.NEED_MODIFY_PWD)) {
    next({ name: 'change-password' })
  } else if (to.meta.auth && !auth(to.meta.auth)) {
    Notify({
      message: i18n.t('您没有访问该页面的权限，请联系管理员'),
      type: 'warning'
    })
    next({ name: 'home' })
  } else next()
})

Vue.prototype.$back = function () {
  if (this.$root.historyStack || window.history.length) {
    this.$root.$$backing = true
    this.$router.back()
  } else {
    const fallback = this.$route.meta.parentName || 'home'
    this.$router.replace({ name: fallback })
  }
}

Vue.prototype.$apis = services((config) => {
  const pgt = ls.get(LS_KEYS.PGT)
  const username = ls.get(LS_KEYS.ACCOUNT)
  if (!pgt || !username) {
    !isLoginPage(router.currentRoute) && router.push({ name: getLoginPageName() })
    return fetchNothing()
  } else if (config.url === '/api/v1/specialdelivery/GetSpecialDeliveryList') {
    return fetch({
      ...config,
      headers: {
        PGT: pgt,
        Lang: ls.get(LS_KEYS.LOCALE),
        // Account: username,
        ...(config.headers || {})
      },
      onBusinessError: data => {
        if (data.ErrorCode === '4001') {
          if (!isLoginPage(router.currentRoute)) {
            Notify({
              message: i18n.t('登录已失效，请重新登录'),
              type: 'warning'
            })
            ls.remove(LS_KEYS.PGT)
            router.push({ name: getLoginPageName() })
          }
        } else {
          if (typeof config.onBusinessError === 'function') {
            return config.onBusinessError(data)
          } else return true
        }
      }
    })
  } else {
    return fetch({
      ...config,
      headers: {
        PGT: pgt,
        Lang: ls.get(LS_KEYS.LOCALE),
        Account: username,
        ...(config.headers || {})
      },
      onBusinessError: data => {
        if (data.ErrorCode === '4001') {
          if (!isLoginPage(router.currentRoute)) {
            Notify({
              message: i18n.t('登录已失效，请重新登录'),
              type: 'warning'
            })
            ls.remove(LS_KEYS.PGT)
            router.push({ name: getLoginPageName() })
          }
        } else {
          if (typeof config.onBusinessError === 'function') {
            return config.onBusinessError(data)
          } else return true
        }
      }
    })
  }
})

Vue.prototype.$auth = auth

let authorizations = null
Vue.prototype.$authorize = key => {
  if (!authorizations) {
    authorizations = ls.get(LS_KEYS.AUTHORIZATION)
  }

  if (authorizations && authorizations instanceof Object) {
    return authorizations[key]
  } else {
    !isLoginPage(router.currentRoute) && router.push({ name: getLoginPageName() })
    return false
  }
}

new Vue({
  i18n,
  router: router,
  render: h => h(App)
}).$mount('#app')

// test_si 1234rewq!@#$
